import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CalendarIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { SEO } from '../components/SEO';
export const blogPosts = [{
  id: 'family-caregiver-model-benefits',
  title: 'The Emotional and Financial Benefits of the Family Caregiver Model',
  excerpt: 'Discover how hiring a family member as a professional caregiver can improve patient outcomes and provide financial stability for families.',
  content: 'Full content here...',
  author: 'Sarah Jenkins, RN',
  date: 'June 15, 2026',
  category: 'Family Caregiving',
  image: 'https://cdn.magicpatterns.com/uploads/d21285LcJafbyi78PZ8pWf/image.png'
}, {
  id: 'navigating-home-health-certification',
  title: 'Navigating the Path to Professional Caregiver Certification',
  excerpt: 'A comprehensive guide on what to expect during the background check, training, and approval process for new caregivers.',
  content: 'Full content here...',
  author: 'Michael Chen',
  date: 'June 10, 2026',
  category: 'Certification',
  image: 'https://cdn.magicpatterns.com/uploads/qVkwCzEK8fKzHzJ27wRNP2/image.png'
}];
export function BlogPage() {
  return <main data-id="element-394">
      <SEO title="Blog | Insights on Home Health & Family Caregiving" description="Stay informed with the latest news, tips, and guides on home health care and the family caregiver model from Ambient Solutions LLC." data-id="element-395" />
      <PageHero title="Our Blog" subtitle="Insights, guides, and stories from the heart of home health care" data-id="element-396" />

      <section className="py-24 px-4 bg-white" data-id="element-397">
        <div className="max-w-7xl mx-auto" data-id="element-398">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-399">
            {blogPosts.map((post, index) => <motion.article key={post.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group flex flex-col bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300" data-id="element-400">
                <Link to={`/blog/${post.id}`} className="block overflow-hidden aspect-[16/9]" data-id="element-401">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-402" />
                </Link>

                <div className="p-8 flex flex-col flex-1" data-id="element-403">
                  <div className="flex items-center gap-4 mb-4" data-id="element-404">
                    <span className="bg-accent-light text-primary px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-405">
                      {post.category}
                    </span>
                    <div className="flex items-center gap-1 text-neutral-medium text-xs" data-id="element-406">
                      <CalendarIcon className="w-3.5 h-3.5" data-id="element-407" />
                      {post.date}
                    </div>
                  </div>

                  <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4 group-hover:text-primary transition-colors" data-id="element-408">
                    <Link to={`/blog/${post.id}`} data-id="element-409">{post.title}</Link>
                  </h2>

                  <p className="text-neutral-medium mb-6 line-clamp-3" data-id="element-410">
                    {post.excerpt}
                  </p>

                  <div className="mt-auto pt-6 border-t border-gray-50 flex items-center justify-between" data-id="element-411">
                    <div className="flex items-center gap-2 text-sm text-neutral-dark font-medium" data-id="element-412">
                      <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-413">
                        <UserIcon className="w-4 h-4 text-primary" data-id="element-414" />
                      </div>
                      {post.author}
                    </div>
                    <Link to={`/blog/${post.id}`} className="text-primary font-bold text-sm flex items-center gap-1 group/link" data-id="element-415">
                      Read More
                      <ArrowRightIcon className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" data-id="element-416" />
                    </Link>
                  </div>
                </div>
              </motion.article>)}
          </div>
        </div>
      </section>
    </main>;
}